import React from "react";
import { Link } from "react-router-dom";

/**
 * Footer Component - Clean, minimal footer
 */
const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-50 to-gray-100 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Main Content */}
        <div className="flex flex-col items-center text-center space-y-4">
          {/* Brand */}
          <h3 className="text-xl font-bold bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
            BibeCheck
          </h3>

          {/* Links */}
          <div className="flex items-center gap-4 text-base">
            <Link
              to="/privacy"
              className="text-gray-600 hover:text-purple-600 transition-colors"
            >
              Privacy
            </Link>
            <span className="text-gray-300">•</span>
            <Link
              to="/terms"
              className="text-gray-600 hover:text-purple-600 transition-colors"
            >
              Terms
            </Link>
            <span className="text-gray-300">•</span>
            <a
              href="mailto:jeyner@bibecheck.com"
              className="text-gray-600 hover:text-purple-600 transition-colors"
            >
              Contact
            </a>
          </div>

          {/* Copyright & Credit */}
          <p className="text-sm text-gray-500">
            © {new Date().getFullYear()} BibeCheck • Made with 💜
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
